import React from "react";
import { ArrowLeft, RefreshCw, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate, useParams } from "react-router-dom";

interface NavigationTitleRowProps {
  isRefreshing: boolean;
  refreshData: () => void;
  isProcessing: boolean;
  waitlistLength: number;
}

export default function NavigationTitleRow({
  isRefreshing,
  refreshData,
}: NavigationTitleRowProps) {
  const navigate = useNavigate();
  const { eventUuid } = useParams<{ eventUuid: string }>();

  const handleBack = () => {
    navigate(`/admin/events/${eventUuid}/sessions`);
  };

  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-4">
        <Button
          onClick={handleBack}
          size="icon"
          variant="outline"
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <div>
          <h1 className="text-2xl font-normal text-gray-900 dark:text-white">
            Session Management
          </h1>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
            Manage session roster, attendance, and billing
          </p>
        </div>
      </div>
      <div className="flex gap-3">
        <Button
          disabled={isRefreshing}
          onClick={refreshData}
          size="sm"
          variant="outline"
        >
          {isRefreshing ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Refreshing...
            </>
          ) : (
            <>
              <RefreshCw className="mr-2 h-4 w-4" />
              Refresh Data
            </>
          )}
        </Button>
      </div>
    </div>
  );
}
